import { PositionsScreenRow, toGridRow } from 'app/models/positions-screen-row'
import { LendersPositionWithMapping } from 'app/models/lenders-position-params'

/**
 * The grid's rows from the read's (ADR_LOS-030): the server resolved every
 * name, summed the loan positions and computed the past-due flag; here the
 * amounts are formatted in the facility's currency, as the page always showed
 * them. The three tabs render these same rows with their columns reordered.
 */
export const toGridRows = (rows: PositionsScreenRow[]): LendersPositionWithMapping[] =>
  rows.map(toGridRow)
